import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { NoAccessScreen } from './alliance/system-screens';

/**
 * Agent staff without the Wallet permission on a purchase or register
 * page. Shown in the page (it used to redirect home without a word); info
 * tone, since nothing is broken.
 */
export function PurchaseNoAccess() {
  // Hooks
  const navigate = useNavigate();

  return (
    <Box role="main">
      <Helmet>
        <title>Alliance Events · Tickets</title>
      </Helmet>

      <NoAccessScreen
        layout="inline"
        title="You don’t have access to buy tickets"
        contact="Ask the agent you’re staff for to add the Wallet permission."
        onHome={() => navigate('/')}
      />
    </Box>
  );
}
